import clsx from 'clsx'

import styles from './BaseBadge.module.scss'

interface BaseBadgeProps {
  count?: number
  className?: string
  status?: 'success' | 'error' | 'default' | 'processing' | 'warning'
  isMiniCart?: boolean
}

function BaseBadge(props: BaseBadgeProps) {
  const {
    count = 0,
    className = '',
    status = 'default',
    isMiniCart = false,
  } = props

  const statusColor = () => {
    switch (status) {
      case 'success': {
        return '#52c41a'
      }
      case 'error': {
        return '#ff4d4f'
      }
      case 'default': {
        return '#000'
      }
      case 'processing': {
        return '#1890ff'
      }
      case 'warning': {
        return '#faad14'
      }
      default: {
        return '#d9d9d9'
      }
    }
  }

  const displayQuantity = () => {
    if (isMiniCart && count > 99) {
      return '99+'
    }
    if (count > 999) {
      return '999+'
    }
    return count
  }

  return count && count > 0
    ? (
      <span
        className={clsx(className, `${styles.container} ${styles.bounceIn}`)}
        style={{ background: statusColor() }}
      >
        {displayQuantity()}
      </span>
    )
    : (
      ''
    )
}

export default BaseBadge
